<template>
    <div id="app">
        <router-view :class="showTabbar ? 'router-view-reset' : ''" />
        <van-tabbar v-model="activeTabbar" active-color="#222222" inactive-color="#999999" @change="onChange"
                    v-show="showTabbar">
            <van-tabbar-item v-for="(item, index) in tabBarList" :key="'tabbar_'+index" :name="item.methodUrl">
                <span>{{ item.menuName }}</span>
                <template #icon="props">
                    <img :src="activeTabbar==item.methodUrl?item.iconHover:item.icon" />
                </template>
            </van-tabbar-item>
        </van-tabbar>
        <!--登录弹窗-->
        <van-popup v-model="showLoginPop" position="bottom" round :close-on-click-overlay="false"
                   :safe-area-inset-bottom="true">
            <van-form @submit="onSubmit" class="login-pop" ref="formDataRef">
                <div class="login-pop-title">
                    请先登录
                    <van-icon class="cross-pop" name="cross" size="0.5rem" @click="onCloseLoginPop"
                              v-if="isShowClose" />
                </div>
                <div class="login-pop-subtitle">登录后可复制、保存定制的精准答案</div>
                <div class="login-form">
                    <van-field v-model="formData.username" type="username" name="username" label="" class="form-name"
                               placeholder="请输入手机号" maxlength="11"
                               :rules="[{ required: true, message: '' },{ pattern: /^1[3-9]\d{9}$/, message:'手机号不正确'}]" />

                    <van-field v-model="formData.sms" center clearable label="" placeholder="请输入验证码"
                               :rules="[{ required: true, message: '' }]" maxlength="6">
                        <template #button>
                            <van-button class="form-sms" v-if="!isSms" native-type="button"
                                        @click="onHandSms" :disabled="buttonLoading">{{smsMessage}}
                            </van-button>
                            <van-count-down :time="time" format="ss s已发送" @finish="timeFinish"
                                            ref="countDown" v-else />
                        </template>
                    </van-field>
                </div>
                <div style="padding-bottom: 0.1rem;">
                    <van-button block type="info" color="#4051B5" native-type="submit">登录</van-button>
                </div>
            </van-form>
        </van-popup>
        <!--客服弹窗-->
        <van-popup v-model="showCustomerPop" round>
            <div class="app-customer-pop">
                <!--<img src="../static/img/customer_bg.png" alt="">-->
                <div class="qrcode-box">
                    <!--<img src="../static/img/placard/qrCode33.png" alt="">-->
                    <img src="https://tiyuxiong.cn/fastdfs/group1/M00/00/1F/rBAAZGUo-0-AKX8OAAM3RauYaAI628.png" alt="">
                </div>
            </div>
        </van-popup>
        <div class="fix-position" @click="onJumpToUrl" v-if="hasCustomer">
            <img src="../static/img/common/followup.png" alt="">
        </div>
    </div>
</template>

<script>
    import {getPublicAndPrivateKey, setPublicAndPrivateKey} from "@/util/PublicAndPrivateKey";
    import wechatOpenId from './util/wechatOpenId.js';
    import {getTraceAPI, oauthTokenAPI, sendMsgCodeAPI} from '@/modle/login.js';
    import jsCookie from 'js-cookie';
    import tokenUtil from "./util/tokenUtil";
    import store from "@/store";
    import splitUrlUtil from "@/util/splitUrlUtil";

    export default {
        name: "App",
        data() {
            return {
                activeTabbar: 'login',
                hasCustomer: this.$store.state.hasCustomer,
                showTabbar: this.$store.state.hiddenTabBar,
                tabBarList: [
                    {
                        menuName: "熊AI",
                        icon: require('../static/img/tabbar/bear.png'),
                        iconHover: require('../static/img/tabbar/bear_hover.png'),//选中的图标
                        methodUrl: "login",
                    },
                    {
                        menuName: "使用记录",
                        methodUrl: "UseRecord",
                        icon: require('../static/img/tabbar/book.png'),
                        iconHover: require('../static/img/tabbar/book_hover.png'),//选中的图标
                    },
                    {
                        menuName: "我的",
                        methodUrl: "myIndex",
                        icon: require('../static/img/tabbar/my.png'),
                        iconHover: require('../static/img/tabbar/my_hover.png'),//选中的图标
                    }
                ],
                showLoginPop: false,
                formData: {
                    username: '',
                    sms: '',
                },
                time: 60 * 1000,
                isSms: false,
                smsMessage: '获取验证码',
                showCustomerPop: false,
                isShowClose: true,
                buttonLoading: false
            };
        },
        provide() {
            return {
                changeVal: this.changeStatus
            }
        },
        methods: {
            onJumpToUrl() {
                window.location.href = 'https://mp.weixin.qq.com/s/uQzkd1FrrVpQOhOPzAMtQw';
            },
            async getTrace(callback) {
                try {
                    let {data, code, message} = await getTraceAPI();
                    if (Number(code) === 0) {
                        console.log('data', data)
                        setPublicAndPrivateKey(data);
                        callback && callback()
                    } else {
                        this.$toast(message)
                    }
                } catch (e) {
                    throw Error(e)
                }
            },
            changeStatus(val, type) {
                this.showLoginPop = val;
                this.isSms = false;
                if (type === 0) {
                    this.isShowClose = false
                } else {
                    this.isShowClose = true
                }
            },
            onChange(name) {
                this.$router.push({
                    name,
                });
            },
            onSubmit(values) {
                console.log('submit', values);
                /*this.showLoginPop = false;
                this.$toast({
                    icon: 'success',
                    message: '登录成功'
                });*/
                this.oauthToken();
            },
            onCloseLoginPop() {
                this.showLoginPop = false;
                this.$store.commit("CHANGE_ACCOUNT", false);
            },
            timeFinish() {
                // this.$toast('倒计时结束');
                this.isSms = false;
                this.smsMessage = '重新发送';
            },
            /*发送验证码*/
            onHandSms() {
                console.log('wwww')
                this.$refs.formDataRef.validate('username').then(async res => {
                    this.buttonLoading = true;
                    try {
                        let {data, code, message} = await sendMsgCodeAPI({
                            phone: this.formData.username
                        });
                        console.log('data, code, message', data, code, message);
                        if (Number(code) === 0) {
                            this.isSms = true;
                            this.time = 60 * 1000;
                        } else {
                            this.$toast(message || '验证码已发送')
                        }
                        this.buttonLoading = false;
                    } catch (e) {
                        this.buttonLoading = false;
                        throw Error(e)
                    }
                }).catch(err => {
                    console.log('err', err)
                });
            },
            // 登录
            async oauthToken() {
                this.$toast.loading({
                    message: '加载中...',
                    duration: 0,
                    forbidClick: true
                });
                const {username, sms} = this.formData;
                let inviteCode = '';
                let registSouc = '';
                let query = splitUrlUtil.getUrlParams();
                console.log('query[\'invite\']', query['invite'])
                if (query["invite"] !== undefined) {
                    inviteCode = Base64.decode(query["invite"])
                }
                if (query["registSouc"] !== undefined) {
                    registSouc = query["registSouc"]
                }
                try {
                    let {data, code, message} = await oauthTokenAPI({
                        password: sms,
                        mpOpenId: jsCookie.get("wechatOpenId"),
                        username,
                        inviteCode,
                        registSouc
                    });
                    console.log('data, code, message', data, code, message);
                    if (Number(code) === 0) {
                        tokenUtil.setToken(
                            data.value,
                            data.refreshToken.value || "",
                            data.additionalInformation.ucode,
                            data.tokenType,
                            data.expiresIn
                        );
                        store.commit("changeLogin", true);
                        await wechatOpenId.userInfo();
                        this.showLoginPop = false;
                        this.$toast({
                            icon: 'success',
                            message: '登录成功'
                        });
                    } else {
                        store.commit("changeLogin", false);
                        this.$toast(message);
                    }
                } catch (e) {
                    this.$toast.clear();
                    throw Error(e)
                }
            }
        },
        created() {
            const {publicKey, privateKey, signKey, clientKey} = getPublicAndPrivateKey();
            if (!publicKey || !privateKey || !signKey || !clientKey) {
                this.getTrace(() => {
                    wechatOpenId.getOpenId();
                });
            } else {
                wechatOpenId.getOpenId();
            }
        },
        mounted() {
        },
        watch: {
            "$store.state.hiddenTabBar": {
                handler(newVal) {
                    this.showTabbar = newVal;
                },
            },
            // 新增帐号异常逻辑
            "$store.state.isAccount": {
                handler(newVal) {
                    console.log('newVal', newVal);
                    console.log('this.$store.state.isLogin', this.$store.state.isLogin);
                    if (!this.$store.state.isLogin && newVal) {
                        this.showLoginPop = newVal;
                    }
                },
            },
            "$store.state.hasCustomer": {
                handler(newVal) {
                    this.hasCustomer = newVal;
                },
            },
            $route: {
                handler(newVal, oldVal) {
                    this.activeTabbar = newVal.name;
                }
            }
        },
    };
</script>

<style lang="scss">
    @import "./assets/css/common.scss";
    //课程相关样式
    @import "./assets/css/myvant.scss";

    html, body {
        width: 100%;
        height: 100%;
        font-family: "Microsoft YaHei";
        // background: #F5F6F7;
        background-color: #F5F6F7; //底部默认背景色
        box-sizing: border-box;
    }

    body {
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom); //页面主体内容限定在安全区域内
    }

    .router-view-reset {
        padding-bottom: 110px;
    }

    .login-pop {
        padding: 46px 44px 10px;
        font-size: 36px;

        .cross-pop {
            position: absolute;
            right: 0;
            top: 0;
        }

        &-title {
            padding: 0 6px;
            position: relative;
            font-size: 48px;
            font-weight: 500;
            color: #222222;
            line-height: 68px;
            font-family: PingFangSC-Medium, PingFang SC;
        }

        &-subtitle {
            padding: 16px 6px 0;
            font-size: 34px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 48px;
        }

        .login-form {
            padding: 72px 4px 124px;

            .van-field__error-message {
                height: 0.42rem;
                line-height: 0.42rem;
            }
        }

        .van-cell {
            padding: 0 0.36rem 0 0.98rem;
            font-size: 0.32rem;
            height: 1.24rem;
            line-height: 1.24rem;
            background-color: #F8F8F8;
            border-radius: 0.16rem;
            background-image: url("../static/img/lock.png");
            background-size: 0.34rem 0.38rem;
            background-position: 0.41rem center;
            background-repeat: no-repeat;
            overflow: visible;

            &.form-name {
                margin-bottom: 0.42rem;
                background-image: url("../static/img/phone_icon.png");
                background-size: 0.29rem 0.38rem;
            }
        }

        .van-button {
            height: 0.88rem;
            line-height: 0.88rem;
            border-radius: 0.1rem;
            font-size: 0.32rem;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #FFFFFF;
        }

        .van-count-down, .form-sms {
            padding: 0;
            border: none;
            height: auto;
            line-height: normal;
            background-color: transparent;
            font-size: 0.32rem;
            color: #4051B5;
            display: flex;
        }
    }

    .fix-position {
        position: fixed;
        bottom: 150px;
        right: 20px;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom); //页面主体内容限定在安全区域内

        img {
            width: 80px;
            height: 80px;
            display: block;
        }
    }

    .app-customer-pop {
        width: 637px;
        height: 891px;
        background-image: url("../static/img/customer_bg.png");
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        box-sizing: border-box;
        padding: 311px 78px 100px;
    }

    .qrcode-box {
        width: 480px;
        height: 480px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 25px;
        border: 1px solid #6070CE;
        padding: 10px;

        img {
            width: 460px;
            height: 460px;
            display: block;
        }
    }

    .api-content {
        flex: 1;
        padding: 0 30px;
        font-size: 24px;

        p, h1, h2, h3, h4, h5, h6 {
            margin: 16px 0;
        }

        code {
            border-radius: 2px;
            color: #e96900;
            margin: 0 2px;
            padding: 3px 5px;
            white-space: pre-wrap;
        }

        table {
            border-collapse: collapse;
            border-spacing: 0;

            th, td {
                border: 1px solid #ddd;
                padding: 6px 13px;
                margin: 0;
            }
        }

        pre {
            padding: 20px 30px;
            background: rgba(0, 0, 0, 0.7);
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue